// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2ZmQt","messages":"Chat_messages__2eQi-","dateDivider":"Chat_dateDivider__9RyWX"};